// soil-keys.ts
export const SOIL_KEYS = [
  "pH",
  "C",
  "N",
  "P",
  "K",
  "CEC",
  "Bulkdensity",
  "Soil_Texture",
] as const;

export type CanonicalKey = typeof SOIL_KEYS[number];

export function isCanonicalKey(x: string): x is CanonicalKey {
  return (SOIL_KEYS as readonly string[]).includes(x);
}
